export default __webpack_public_path__ + "static/media/ldpe-film-bales.519b5c3b.jpg";